/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wd_PreviewInputs */

const en_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const ar_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة`)
};

const bn_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রিভিউ`)
};

const de_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau`)
};

const es_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa`)
};

const fr_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

const pt_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização`)
};

const zh_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览`)
};

const tr_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önizleme`)
};

const ru_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр`)
};

const pl_wd_preview = /** @type {(inputs: Wd_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podgląd`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Wd_PreviewInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_preview = /** @type {((inputs?: Wd_PreviewInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_PreviewInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_preview(inputs)
	if (locale === "bn") return bn_wd_preview(inputs)
	if (locale === "de") return de_wd_preview(inputs)
	if (locale === "es") return es_wd_preview(inputs)
	if (locale === "fr") return fr_wd_preview(inputs)
	if (locale === "pt") return pt_wd_preview(inputs)
	if (locale === "zh") return zh_wd_preview(inputs)
	if (locale === "tr") return tr_wd_preview(inputs)
	if (locale === "ru") return ru_wd_preview(inputs)
	if (locale === "pl") return pl_wd_preview(inputs)
	return en_wd_preview(inputs)
});